module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/volodymyr-ivash-avatar-d2b10914564d56143b49d9e3c50c911d.jpg";